import styled, { css } from "styled-components"
import { Paragraph, ParagraphTitle, Label } from "@components/Typography"
import { AnchorStyle } from "@components/Typography/TextStyles/Anchor"
import { CleanButton } from "@components/Buttons"
import { LabelStyle } from "@components/Typography/TextStyles/Label"
import { lighten, darken } from "polished"

export const ContactLink = styled(Paragraph)`
  margin: 0;

  a {
    ${AnchorStyle};
    color: ${(p) => p.theme.colors.purple};
    font-size: 1rem;
  }
`

export const Title = styled(ParagraphTitle)`
  margin-bottom: 0.25rem;
`

export const ContactWrapper = styled.div`
  display: flex;
  align-items: center;

  span {
    flex: 0 0 15%;
    font-weight: bold;
    text-transform: uppercase;
  }
`

export const Subtitle = styled(Label)`
  opacity: 0.5;
  margin-bottom: 1rem;
  margin-top: 0;
`

export const Content = styled.div`
  margin-bottom: 1rem;
`

export const ToggleButton = styled(CleanButton)<{ open: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: 0;
  ${LabelStyle};
  color: ${(p) => lighten(0.1, p.theme.colors.text.light)};
  margin: 0.75rem 0 0.5rem 0;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${(p) => darken(0.1, p.theme.colors.text.light)};
  }
  svg {
    transition: transform 0.2s ease-in-out;
    width: 0.75rem;
    height: 0.75rem;
    fill: currentColor;
    margin-left: 0.75rem;
    ${(p) =>
      p.open &&
      css`
        transform: rotate(-180deg);
      `};
  }
`
